import React, { useState } from 'react'

import { ColumnFlexDiv, RowFlexDiv, Icon, SearchInput } from '../RightNavStyles'
import {
  NudistaSemiBold13,
  NudistaBold14,
  NudistaMedium9,
  HelveticaNeueRegular14,
  HelveticaNeueBold14,
  NudistaMedium11,
} from '../../Common/Fonts'
import {
  UserProfilePictureHolder,
  UserProfilePicture,
} from '../../Common/CommonStyle'
import ArrowThin from '../../Common/ArrowThin'
import PlusButton from '../../Common/PlusButton'
import { useHistory } from 'react-router-dom'
import OnlineStatus from '../../Common/OnlineStatus'
import CreateButton from '../../Common/CreateButton'

const assignments = [
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
]

const Assignments = ({ rightNavbarMinified, setRightNavbarMinified }) => {
  const history = useHistory()
  const [activeView, setActiveView] = useState(1)

  return (
    <ColumnFlexDiv
      gap='20px'
      margin='0 0 0 24px'
      position='relative'
      height='100%'
      justifyContent='flex-start'
      alignItems='flex-start'
    >
      <ColumnFlexDiv gap='0px' width='100%'>
        <RowFlexDiv
          height='20px'
          width={rightNavbarMinified ? '60%' : '95%'}
          justifyContent='flex-end'
          alignItems='flex-start'
        >
          <ArrowThin
            width='20%'
            rotate={!rightNavbarMinified}
            onClickHandler={() => {
              console.log('rightnavbarMinified is', rightNavbarMinified)
              setRightNavbarMinified(!rightNavbarMinified)
            }}

            // rotate={!rightNavbarMinified}
            // onClickHandler={() => {
            //   console.log(rightNavbarMinified)
            //   setRightNavbarMinified(!rightNavbarMinified)
            // }}
          />
        </RowFlexDiv>
        <RowFlexDiv
          width={rightNavbarMinified ? '0%' : '100%'}
          opacity={rightNavbarMinified ? '0' : '1'}
          justifyContent='flex-start'
        >
          <RowFlexDiv
            width='48%'
            height='30px'
            gap='5px'
            justifyContent='center'
            outline='1px solid #6D0BF7'
            backgroundColor={activeView === 1 ? '#6D0BF7' : '#FFFFFF'}
            Cursor='pointer'
            onClick={() => {
              setActiveView(1)
              history.push('/map-view')
            }}
          >
            <Icon
              src={
                activeView === 1
                  ? '/images/navbar/assignment-ico.svg'
                  : '/images/navbar/assignment.svg'
              }
              alt='assignments'
            />
            <HelveticaNeueBold14
              color={activeView === 1 ? 'whiteColor' : 'primary'}
            >
              Assignments
            </HelveticaNeueBold14>
          </RowFlexDiv>

          <RowFlexDiv
            width='48%'
            height='30px'
            gap='5px'
            justifyContent='center'
            outline='1px solid #6D0BF7'
            backgroundColor='#FFFFFF'
            backgroundColor={activeView === 2 ? '#6D0BF7' : '#FFFFFF'}
            Cursor='pointer'
            onClick={() => {
              setActiveView(2)

              history.push('/week-view')
            }}
          >
            <Icon
              src={
                activeView === 2
                  ? '/images/navbar/contacts_white.svg'
                  : '/images/navbar/contacts.svg'
              }
              alt='assignments'
            />
            <HelveticaNeueBold14
              color={activeView === 2 ? 'whiteColor' : 'primary'}
            >
              Contacts
            </HelveticaNeueBold14>
            {/* <NudistaBold14 color='primary'></NudistaBold14> */}
          </RowFlexDiv>
        </RowFlexDiv>
      </ColumnFlexDiv>

      <RowFlexDiv
        width='95%'
        gap='5px'
        opacity={rightNavbarMinified ? '0' : '1'}
      >
        <DesignedButton width='36px' title='All' />
        <DesignedButton width='83px' title='Not Started' />
        <DesignedButton width='74px' title='In Progress' />
        <DesignedButton width='53px' title='Done' />
      </RowFlexDiv>

      {activeView == 1 ? (
        <AssignmentsProfile rightNavbarMinified={rightNavbarMinified} />
      ) : (
        <ContactsProfile rightNavbarMinified={rightNavbarMinified} />
      )}

      <RowFlexDiv
        width='81%'
        // height='90%'
        marginTop='92vh'
        backgroundColor='#123456'
        position='absolute'
        alignItems='flex-end'
        opacity={rightNavbarMinified ? '0' : '1'}
        zIndex='1'
      >
        <CreateButton title='Create New Assignment' />
      </RowFlexDiv>
    </ColumnFlexDiv>
  )
}
const DesignedButton = ({ width, title }) => {
  return (
    <RowFlexDiv
      width={width}
      height='25px'
      borderRadius='13px'
      backgroundColor={
        title === 'All' ? 'rgba(106,38,202, 1)' : 'rgba(106,38,202, 0.09)'
      }
      alignItems='center'
      justifyContent='center'
    >
      <NudistaMedium11
        opacity={title === 'All' ? '1' : '0.27'}
        color={title === 'All' ? 'whiteColor' : 'lightBlack'}
      >
        {title}
      </NudistaMedium11>
    </RowFlexDiv>
  )
}

const AssignmentsProfile = ({ rightNavbarMinified }) => {
  return (
    <>
      {assignments?.map((value) => (
        <RowFlexDiv
          width={rightNavbarMinified ? '80%' : '90%'}
          height='35px'
          overflow='hidden'
        >
          <UserProfilePictureHolder
            width='40px'
            height='40px'
            borderRadius='0%'
          >
            <UserProfilePicture
              width='40px'
              alt={value.name}
              src={value.icon}
            />
          </UserProfilePictureHolder>
          <OnlineStatus
            marginLeft={rightNavbarMinified ? '31%' : '13%'}
            marginTop={rightNavbarMinified ? '-28%' : '-11%'}
          />
          <ColumnFlexDiv
            height='100%'
            padding='5px 0px 0px 0px'
            justifyContent='center'
            width={rightNavbarMinified ? '0px' : '60%'}
            opacity={rightNavbarMinified ? '0' : '1'}
            zIndex={rightNavbarMinified ? '-100' : '1'}
          >
            <NudistaSemiBold13>{value.name}</NudistaSemiBold13>
            <NudistaMedium9 color='primary'>
              Project/claim {value.id}
            </NudistaMedium9>
          </ColumnFlexDiv>
          <Icon src='/images/navbar/three-dots.svg' alt='options' />
        </RowFlexDiv>
      ))}
    </>
  )
}

const ContactsProfile = ({ rightNavbarMinified }) => {
  return (
    <>
      {assignments?.map((value) => (
        <RowFlexDiv
          width={rightNavbarMinified ? '80%' : '90%'}
          height='35px'
          overflow='hidden'
        >
          <UserProfilePictureHolder
            width='35px'
            height='35px'
            borderRadius='50%'
          >
            <UserProfilePicture
              width='40px'
              alt={value.name}
              src={value.icon}
            />
          </UserProfilePictureHolder>
          <OnlineStatus
            marginLeft={rightNavbarMinified ? '23.5%' : '10%'}
            marginTop={rightNavbarMinified ? '-24%' : '-10%'}
          />

          <ColumnFlexDiv
            height='100%'
            padding='5px 0px 0px 0px'
            justifyContent='center'
            width={rightNavbarMinified ? '0px' : '60%'}
            opacity={rightNavbarMinified ? '0' : '1'}
            zIndex={rightNavbarMinified ? '-100' : '1'}
          >
            <NudistaSemiBold13>{value.name}</NudistaSemiBold13>
          </ColumnFlexDiv>
          <Icon src='/images/navbar/three-dots.svg' alt='options' />
        </RowFlexDiv>
      ))}
    </>
  )
}

export default Assignments
